export default __webpack_public_path__ + "static/media/excelstep1.7bf086a2.png";